import { c as _c } from "react/compiler-runtime";
import { useAsanaIntegration } from '@/data/asana/use-asana-integration';
import { useAssociatedAsanaIssue } from '@/data/asana/use-associated-issue';

/**
 * The Asana task linked to a pull request, with the connection gating the PR page sidebar and
 * the /code PR tab share. Null while the installation has no Asana connection with a workspace,
 * or without a valid PR number; the linked-task request waits for the connection.
 */
export function useLinkedAsanaIssue(t0) {
  const $ = _c(5);
  const {
    owner,
    repo,
    pullNumber,
    installationId
  } = t0;
  const {
    connection
  } = useAsanaIntegration(installationId ?? undefined);
  const connectionId = connection?.nangoConnectionId;
  const workspaceGid = connection?.workspaceGid;
  const prNumber = Number.isInteger(pullNumber) && pullNumber > 0 ? pullNumber : 0;
  const t1 = !!connectionId;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      enabled: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const associatedIssue = useAssociatedAsanaIssue(owner, repo, prNumber, t2);
  if (!connectionId || !workspaceGid || !installationId || prNumber <= 0) {
    return null;
  }
  let t3;
  if ($[2] !== associatedIssue || $[3] !== installationId) {
    t3 = {
      ...associatedIssue,
      installationId
    };
    $[2] = associatedIssue;
    $[3] = installationId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}